module.exports = __webpack_public_path__ + "img/67.10.pH.2f1c46e0.png";